import { render, staticRenderFns } from "./InpatientReviewRecommendations.vue?vue&type=template&id=6c9e26af&"
import script from "./InpatientReviewRecommendations.vue?vue&type=script&lang=js&"
export * from "./InpatientReviewRecommendations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports